// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"21000233","651":"5ddd8906","726":"55cda4d7"}[chunkId] + ".chunk.js";
};